module.exports = __webpack_public_path__ + "img/Arma 3 Unit Newfound Pioneer Corps.1832ba98.webp";